import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { VariantContextData } from "../variants/VariantBuilderContext";
import useReviewRecommendations from "../review_recommendations/useReviewRecommendations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NewReviewRecommendation = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  const { ReviewRecommendations } = useReviewRecommendations();

  const onClick = (e) => {
    if (builder.displayFeatureGate(e, 'Conditional Review Recommendations')) {
      ReviewRecommendations.create(props.element, {}, {
        callback: (review_recommendation) => {
          dispatchCustomEvent("focusItem", {
            parent_id: props.element.id,
            item_type: "review_recommendations",
            item_id: review_recommendation.id
          });
        }
      });
    }
  };

  return (
    <React.Fragment>
      <div className="col-xs-12 mb-5">
        <button
          onClick={onClick}
          className="new-review-recommendation w-full p-2 text-left bg-transparent border-none text-xl text-blue-600 dark:text-blue-200 dark:hover:text-white"
          title="Add Conditional Review"
        >
          <FontAwesomeIcon icon="plus-square" className="mr-2 text-2xl" /> Add Conditional Review
        </button>
      </div>
    </React.Fragment>
  );
};

export default NewReviewRecommendation;
